webpackJsonp([1],Array(39).concat([
/* 39 */
/***/ (function(module, exports) {



(function ($) {
    "use strict";

    $(document).on('click', 'a.page-scroll', function (event) {
        var $anchor = $(this);
        $('html, body').stop().animate({
            scrollTop: $($anchor.attr('href')).offset().top - 54
        }, 1250, 'easeInOutExpo');
        event.preventDefault();
    });

    $('body').scrollspy({
        target: '#mainNav',
        offset: 54
    });

    $('.navbar-collapse>ul>li>a').click(function () {
        $('.navbar-collapse').collapse('hide');
    });

    $(window).scroll(function () {
        if ($("#mainNav").offset().top > 100) {
            $("#mainNav").addClass("navbar-shrink");
        } else {
            $("#mainNav").removeClass("navbar-shrink");
        }
    });
})(jQuery);

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);



(function (factory) {
  if (typeof define === "function" && __webpack_require__(119)) {
    define(['jquery'], function ($) {
      return factory($);
    });
  } else if (( false ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(module)) === "object" && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(module.exports) === "object") {
    exports = factory(__webpack_require__(27));
  } else {
    factory(jQuery);
  }
})(function ($) {
  $.easing['jswing'] = $.easing['swing'];

  var pow = Math.pow,
      sqrt = Math.sqrt,
      sin = Math.sin,
      cos = Math.cos,
      PI = Math.PI,
      c1 = 1.70158,
      c2 = c1 * 1.525,
      c3 = c1 + 1,
      c4 = 2 * PI / 3,
      c5 = 2 * PI / 4.5;

  function bounceOut(x) {
    var n1 = 7.5625,
        d1 = 2.75;
    if (x < 1 / d1) {
      return n1 * x * x;
    } else if (x < 2 / d1) {
      return n1 * (x -= 1.5 / d1) * x + .75;
    } else if (x < 2.5 / d1) {
      return n1 * (x -= 2.25 / d1) * x + .9375;
    } else {
      return n1 * (x -= 2.625 / d1) * x + .984375;
    }
  }

  $.extend($.easing, {
    def: 'easeOutQuad',
    swing: function swing(x) {
      return $.easing[$.easing.def](x);
    },
    easeInQuad: function easeInQuad(x) {
      return x * x;
    },
    easeOutQuad: function easeOutQuad(x) {
      return 1 - (1 - x) * (1 - x);
    },
    easeInOutQuad: function easeInOutQuad(x) {
      return x < 0.5 ? 2 * x * x : 1 - pow(-2 * x + 2, 2) / 2;
    },
    easeInCubic: function easeInCubic(x) {
      return x * x * x;
    },
    easeOutCubic: function easeOutCubic(x) {
      return 1 - pow(1 - x, 3);
    },
    easeInOutCubic: function easeInOutCubic(x) {
      return x < 0.5 ? 4 * x * x * x : 1 - pow(-2 * x + 2, 3) / 2;
    },
    easeInQuart: function easeInQuart(x) {
      return x * x * x * x;
    },
    easeOutQuart: function easeOutQuart(x) {
      return 1 - pow(1 - x, 4);
    },
    easeInOutQuart: function easeInOutQuart(x) {
      return x < 0.5 ? 8 * x * x * x * x : 1 - pow(-2 * x + 2, 4) / 2;
    },
    easeInQuint: function easeInQuint(x) {
      return x * x * x * x * x;
    },
    easeOutQuint: function easeOutQuint(x) {
      return 1 - pow(1 - x, 5);
    },
    easeInOutQuint: function easeInOutQuint(x) {
      return x < 0.5 ? 16 * x * x * x * x * x : 1 - pow(-2 * x + 2, 5) / 2;
    },
    easeInSine: function easeInSine(x) {
      return 1 - cos(x * PI / 2);
    },
    easeOutSine: function easeOutSine(x) {
      return sin(x * PI / 2);
    },
    easeInOutSine: function easeInOutSine(x) {
      return -(cos(PI * x) - 1) / 2;
    },
    easeInExpo: function easeInExpo(x) {
      return x === 0 ? 0 : pow(2, 10 * x - 10);
    },
    easeOutExpo: function easeOutExpo(x) {
      return x === 1 ? 1 : 1 - pow(2, -10 * x);
    },
    easeInOutExpo: function easeInOutExpo(x) {
      return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? pow(2, 20 * x - 10) / 2 : (2 - pow(2, -20 * x + 10)) / 2;
    },
    easeInCirc: function easeInCirc(x) {
      return 1 - sqrt(1 - pow(x, 2));
    },
    easeOutCirc: function easeOutCirc(x) {
      return sqrt(1 - pow(x - 1, 2));
    },
    easeInOutCirc: function easeInOutCirc(x) {
      return x < 0.5 ? (1 - sqrt(1 - pow(2 * x, 2))) / 2 : (sqrt(1 - pow(-2 * x + 2, 2)) + 1) / 2;
    },
    easeInElastic: function easeInElastic(x) {
      return x === 0 ? 0 : x === 1 ? 1 : -pow(2, 10 * x - 10) * sin((x * 10 - 10.75) * c4);
    },
    easeOutElastic: function easeOutElastic(x) {
      return x === 0 ? 0 : x === 1 ? 1 : pow(2, -10 * x) * sin((x * 10 - 0.75) * c4) + 1;
    },
    easeInOutElastic: function easeInOutElastic(x) {
      return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(pow(2, 20 * x - 10) * sin((20 * x - 11.125) * c5)) / 2 : pow(2, -20 * x + 10) * sin((20 * x - 11.125) * c5) / 2 + 1;
    },
    easeInBack: function easeInBack(x) {
      return c3 * x * x * x - c1 * x * x;
    },
    easeOutBack: function easeOutBack(x) {
      return 1 + c3 * pow(x - 1, 3) + c1 * pow(x - 1, 2);
    },
    easeInOutBack: function easeInOutBack(x) {
      return x < 0.5 ? pow(2 * x, 2) * ((c2 + 1) * 2 * x - c2) / 2 : (pow(2 * x - 2, 2) * ((c2 + 1) * (x * 2 - 2) + c2) + 2) / 2;
    },
    easeInBounce: function easeInBounce(x) {
      return 1 - bounceOut(1 - x);
    },
    easeOutBounce: bounceOut,
    easeInOutBounce: function easeInOutBounce(x) {
      return x < 0.5 ? (1 - bounceOut(1 - 2 * x)) / 2 : (1 + bounceOut(2 * x - 1)) / 2;
    }
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(121)(module)))

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  base: '/netsix-gh-pages/',
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a
  }]
}));

/***/ }),
/* 42 */,
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(89)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(115),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(41);





window.$ = window.jQuery = __webpack_require__(27);
window.tether = window.Tether = __webpack_require__(44);
__webpack_require__(42);
__webpack_require__(43);

__webpack_require__(40);
__webpack_require__(39);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Home_Services__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Home_Services___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Home_Services__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Home_PortfolioGrid__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Home_PortfolioGrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Home_PortfolioGrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Home_About__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Home_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Home_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Home_Team__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Home_Team___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Home_Team__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Home_Contact__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Home_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Home_Contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Home_PortfolioModals__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Home_PortfolioModals___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Home_PortfolioModals__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  components: {
    PortfolioModals: __WEBPACK_IMPORTED_MODULE_5__Home_PortfolioModals___default.a, Contact: __WEBPACK_IMPORTED_MODULE_4__Home_Contact___default.a, Team: __WEBPACK_IMPORTED_MODULE_3__Home_Team___default.a, About: __WEBPACK_IMPORTED_MODULE_2__Home_About___default.a, PortfolioGrid: __WEBPACK_IMPORTED_MODULE_1__Home_PortfolioGrid___default.a, Services: __WEBPACK_IMPORTED_MODULE_0__Home_Services___default.a
  },
  data: function data() {
    return {
      appName: 'Netsix',
      downloadLink: 'https://github.com/mmorainville/netsix/releases/latest',
      paypalLink: 'https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=MRDR2837QXHK8'
    };
  },

  methods: {
    trackClick: function trackClick(url) {
      window.ga('send', 'event', 'outbound', 'click', url);
    }
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about'
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contact',
  data: function data() {
    return {
      name: '',
      email: '',
      message: ''
    };
  },

  computed: {
    isValidEmail: function isValidEmail() {
      var regex = new RegExp('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}');
      return regex.test(this.email);
    }
  },
  methods: {
    canSubmit: function canSubmit() {
      return this.name && this.isValidEmail && this.message;
    }
  }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'portfolio-grid'
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'portfolio-modals'
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'services'
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'team',
  data: function data() {
    return {
      githubMathieu: 'https://github.com/mmorainville',
      linkedinMathieu: 'https://www.linkedin.com/in/mathieu-morainville-4b72757a',
      githubSylver: 'https://github.com/sylver-john',
      linkedinSylver: 'https://fr.linkedin.com/in/sylver-john-imhoff-975ba595'
    };
  },

  methods: {
    trackClick: function trackClick(url) {
      window.ga('send', 'event', 'outbound', 'click', url);
    }
  }
});

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/step-1-thumbnail.b52a84f.png";

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/step-2-thumbnail.ca70a3c.png";

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/step-3-thumbnail.6940ba8.png";

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/step-4-thumbnail.e89e03d.png";

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/step-5-thumbnail.c7bf791.png";

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/screenshot-connected-01.125db9a.png";

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/screenshot-connected-02.18ee9a7.png";

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/screenshot-connected-03.5d50650.png";

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/screenshot-connected.d59d730.png";

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mathieu.c0efae5.jpg";

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sylver.125591c.png";

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(88)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(113),
  /* scopeId */
  "data-v-3f976f00",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(112),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(87)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(110),
  /* scopeId */
  "data-v-0c379f71",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(109),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(52),
  /* template */
  __webpack_require__(111),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(114),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(116),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bg-faded",
    attrs: {
      "id": "portfolio"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_c('h2', {
    staticClass: "section-heading"
  }, [_vm._v("Screenshots")]), _vm._v(" "), _c('h3', {
    staticClass: "section-subheading text-muted"
  }, [_vm._v("See what it looks like!")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-6 portfolio-item"
  }, [_c('a', {
    staticClass: "portfolio-link",
    attrs: {
      "href": "#portfolioModal1",
      "data-toggle": "modal"
    }
  }, [_c('div', {
    staticClass: "portfolio-hover"
  }, [_c('div', {
    staticClass: "portfolio-hover-content"
  }, [_c('i', {
    staticClass: "fa fa-plus fa-3x"
  })])]), _vm._v(" "), _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": __webpack_require__(95),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "portfolio-caption"
  }, [_c('h4', [_vm._v("Collections")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Lists of videos you want to share or that are available for you to watch.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 portfolio-item"
  }, [_c('a', {
    staticClass: "portfolio-link",
    attrs: {
      "href": "#portfolioModal1",
      "data-toggle": "modal"
    }
  }, [_c('div', {
    staticClass: "portfolio-hover"
  }, [_c('div', {
    staticClass: "portfolio-hover-content"
  }, [_c('i', {
    staticClass: "fa fa-plus fa-3x"
  })])]), _vm._v(" "), _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": __webpack_require__(97),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "portfolio-caption"
  }, [_c('h4', [_vm._v("Streaming")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Choose a video and watch it in streaming in a real peer-to-peer manner.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 portfolio-item"
  }, [_c('a', {
    staticClass: "portfolio-link",
    attrs: {
      "href": "#portfolioModal1",
      "data-toggle": "modal"
    }
  }, [_c('div', {
    staticClass: "portfolio-hover"
  }, [_c('div', {
    staticClass: "portfolio-hover-content"
  }, [_c('i', {
    staticClass: "fa fa-plus fa-3x"
  })])]), _vm._v(" "), _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": __webpack_require__(96),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "portfolio-caption"
  }, [_c('h4', [_vm._v("Chat")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("You can also chat with four friends in a peer-to-peer encrypted way.")])])])])])])
}]}

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "contact"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('form', {
    attrs: {
      "action": "https://formspree.io/netsix.io@gmail.com",
      "method": "POST",
      "name": "sentMessage",
      "id": "contactForm",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": "Your Name *",
      "id": "name",
      "required": "",
      "data-validation-required-message": "Please enter your name."
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help-block text-danger"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "_replyto",
      "placeholder": "Your Email *",
      "id": "email",
      "required": "",
      "data-validation-required-message": "Please enter your email address."
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.email && !_vm.isValidEmail) ? _c('p', {
    staticClass: "help-block text-danger"
  }, [_vm._v("Please enter a valid email address.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "message",
      "placeholder": "Your Message *",
      "id": "message",
      "required": "",
      "data-validation-required-message": "Please enter a message."
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help-block text-danger"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_c('div', {
    attrs: {
      "id": "success"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xl",
    attrs: {
      "type": "submit",
      "disabled": !_vm.canSubmit()
    }
  }, [_vm._v("Send Message")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_c('h2', {
    staticClass: "section-heading"
  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('h3', {
    staticClass: "section-subheading text-muted"
  }, [_vm._v("Please use the contact form for any questions or remarks.")])])])
}]}

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "portfolio-modal modal fade",
    attrs: {
      "id": "portfolioModal1",
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "close-modal",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_c('div', {
    staticClass: "lr"
  }, [_c('div', {
    staticClass: "rl"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('h2', [_vm._v("Netsix")]), _vm._v(" "), _c('p', {
    staticClass: "item-intro text-muted"
  }, [_vm._v("Main view of the app.")]), _vm._v(" "), _c('img', {
    staticClass: "img-fluid d-block mx-auto",
    attrs: {
      "src": __webpack_require__(98),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("Here you can watch videos from your friends' collections.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Close")])])])])])])])])])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "about"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_c('h2', {
    staticClass: "section-heading"
  }, [_vm._v("Getting started")]), _vm._v(" "), _c('h3', {
    staticClass: "section-subheading text-muted"
  }, [_vm._v("Watch videos from your friends in 6 easy steps !")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('ul', {
    staticClass: "timeline"
  }, [_c('li', [_c('div', {
    staticClass: "timeline-image"
  }, [_c('img', {
    staticClass: "rounded-circle img-fluid",
    attrs: {
      "src": __webpack_require__(90),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "timeline-panel"
  }, [_c('div', {
    staticClass: "timeline-heading"
  }, [_c('h4', [_vm._v("Step 1")]), _vm._v(" "), _c('h4', {
    staticClass: "subheading"
  }, [_vm._v("Get your ID")])]), _vm._v(" "), _c('div', {
    staticClass: "timeline-body"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Open the app and click on \"Copy\" in the upper right corner.")])])])]), _vm._v(" "), _c('li', {
    staticClass: "timeline-inverted"
  }, [_c('div', {
    staticClass: "timeline-image"
  }, [_c('img', {
    staticClass: "rounded-circle img-fluid",
    attrs: {
      "src": __webpack_require__(91),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "timeline-panel"
  }, [_c('div', {
    staticClass: "timeline-heading"
  }, [_c('h4', [_vm._v("Step 2")]), _vm._v(" "), _c('h4', {
    staticClass: "subheading"
  }, [_vm._v("Share your ID")])]), _vm._v(" "), _c('div', {
    staticClass: "timeline-body"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Share the ID you just copied with a friend who want to watch your videos.")])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "timeline-image"
  }, [_c('img', {
    staticClass: "rounded-circle img-fluid",
    attrs: {
      "src": __webpack_require__(92),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "timeline-panel"
  }, [_c('div', {
    staticClass: "timeline-heading"
  }, [_c('h4', [_vm._v("Step 3")]), _vm._v(" "), _c('h4', {
    staticClass: "subheading"
  }, [_vm._v("Connect")])]), _vm._v(" "), _c('div', {
    staticClass: "timeline-body"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Enter your friend's ID in the \"Remote\" tab.")])])])]), _vm._v(" "), _c('li', {
    staticClass: "timeline-inverted"
  }, [_c('div', {
    staticClass: "timeline-image"
  }, [_c('img', {
    staticClass: "rounded-circle img-fluid",
    attrs: {
      "src": __webpack_require__(93),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "timeline-panel"
  }, [_c('div', {
    staticClass: "timeline-heading"
  }, [_c('h4', [_vm._v("Step 4")]), _vm._v(" "), _c('h4', {
    staticClass: "subheading"
  }, [_vm._v("Choose your video")])]), _vm._v(" "), _c('div', {
    staticClass: "timeline-body"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Choose a video from your friend's collection in the \"Collections\" panel.")])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "timeline-image"
  }, [_c('img', {
    staticClass: "rounded-circle img-fluid",
    attrs: {
      "src": __webpack_require__(94),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "timeline-panel"
  }, [_c('div', {
    staticClass: "timeline-heading"
  }, [_c('h4', [_vm._v("Step 5")]), _vm._v(" "), _c('h4', {
    staticClass: "subheading"
  }, [_vm._v("Wait a short time")])]), _vm._v(" "), _c('div', {
    staticClass: "timeline-body"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Your friend is automatically preparing the video for you before streaming it.")])])])]), _vm._v(" "), _c('li', {
    staticClass: "timeline-inverted"
  }, [_c('div', {
    staticClass: "timeline-image"
  }, [_c('h4', [_vm._v("Step 6"), _c('br'), _vm._v("Enjoy"), _c('br'), _vm._v("Your video")])])])])])])])])
}]}

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_vm._m(0), _vm._v(" "), _c('header', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "intro-text"
  }, [_c('div', {
    staticClass: "intro-lead-in"
  }, [_vm._v(_vm._s(_vm.appName))]), _vm._v(" "), _c('div', {
    staticClass: "intro-heading"
  }, [_vm._v("A new way to share your videos")]), _vm._v(" "), _c('a', {
    staticClass: "page-scroll btn btn-xl m-2",
    attrs: {
      "href": "#services"
    }
  }, [_vm._v("Tell Me More")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-xl m-2",
    attrs: {
      "href": _vm.downloadLink,
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.trackClick(_vm.downloadLink)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Download")])])])]), _vm._v(" "), _c('services'), _vm._v(" "), _c('portfolio-grid'), _vm._v(" "), _c('about'), _vm._v(" "), _c('team'), _vm._v(" "), _c('contact'), _vm._v(" "), _c('footer', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    staticClass: "copyright"
  }, [_vm._v("Copyright © " + _vm._s(_vm.appName) + " 2017")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('ul', {
    staticClass: "list-inline social-buttons"
  }, [_c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.paypalLink,
      "target": "_blank",
      "title": "Donate"
    },
    on: {
      "click": function($event) {
        _vm.trackClick(_vm.paypalLink)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-paypal"
  })])])])]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('portfolio-modals')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar fixed-top navbar-toggleable-md navbar-inverse",
    attrs: {
      "id": "mainNav"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('button', {
    staticClass: "navbar-toggler navbar-toggler-right",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarResponsive",
      "aria-controls": "navbarResponsive",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_vm._v("\n        Menu "), _c('i', {
    staticClass: "fa fa-bars"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand page-scroll",
    attrs: {
      "href": "#app"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(101)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbarResponsive"
    }
  }, [_c('ul', {
    staticClass: "navbar-nav ml-auto"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link page-scroll",
    attrs: {
      "href": "#services"
    }
  }, [_vm._v("Features")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link page-scroll",
    attrs: {
      "href": "#portfolio"
    }
  }, [_vm._v("Screenshots")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link page-scroll",
    attrs: {
      "href": "#about"
    }
  }, [_vm._v("Getting started")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link page-scroll",
    attrs: {
      "href": "#team"
    }
  }, [_vm._v("Team")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link page-scroll",
    attrs: {
      "href": "#contact"
    }
  }, [_vm._v("Contact")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "https://github.com/mmorainville/netsix",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" GitHub")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    staticClass: "copyright"
  }, [_vm._v("We will not be responsible for any devious usage of the app.")])])
}]}

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "services"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_c('h2', {
    staticClass: "section-heading"
  }, [_vm._v("Features")]), _vm._v(" "), _c('h3', {
    staticClass: "section-subheading text-muted"
  }, [_vm._v("With Netsix, sharing videos with your friends is fast and simple."), _c('br'), _vm._v("\n          Once connected in peer-to-peer, you can stream and watch videos stored on a friend's hard drive as fast as possible."), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/mmorainville/netsix/releases/latest",
      "target": "_blank"
    }
  }, [_vm._v("Download Netsix")]), _vm._v(".")])])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "fa-stack fa-4x"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x text-primary"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-fighter-jet fa-stack-1x fa-inverse"
  })]), _vm._v(" "), _c('h4', {
    staticClass: "service-heading"
  }, [_vm._v("Fast")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Netsix uses WebRTC to create a real peer-to-peer connection.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "fa-stack fa-4x"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x text-primary"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-laptop fa-stack-1x fa-inverse"
  })]), _vm._v(" "), _c('h4', {
    staticClass: "service-heading"
  }, [_vm._v("Simple")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Installing and using Netsix is really simple: just download the app and share your ID.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "fa-stack fa-4x"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x text-primary"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lock fa-stack-1x fa-inverse"
  })]), _vm._v(" "), _c('h4', {
    staticClass: "service-heading"
  }, [_vm._v("Secure")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("The WebRTC connexion is naturally encrypted and no one can see what you are sharing with your friends.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "fa-stack fa-4x"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x text-primary"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-rebel fa-stack-1x fa-inverse"
  })]), _vm._v(" "), _c('h4', {
    staticClass: "service-heading"
  }, [_vm._v("Open Source")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("The code is on "), _c('a', {
    attrs: {
      "href": "https://github.com/mmorainville/netsix",
      "target": "_blank"
    }
  }, [_vm._v("GitHub")]), _vm._v(" and you are free to help improve the app.")])])])])])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bg-faded",
    attrs: {
      "id": "team"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "team-member"
  }, [_c('img', {
    staticClass: "mx-auto rounded-circle",
    attrs: {
      "src": __webpack_require__(99),
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Mathieu Morainville")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Web Developer | JavaScript-Man")]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline social-buttons"
  }, [_c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.githubMathieu,
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.trackClick(_vm.githubMathieu)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-github"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.linkedinMathieu,
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.trackClick(_vm.linkedinMathieu)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "team-member"
  }, [_c('img', {
    staticClass: "mx-auto rounded-circle",
    attrs: {
      "src": __webpack_require__(100),
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Sylver-John Imhoff")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Web Developer | Golang Lover")]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline social-buttons"
  }, [_c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.githubSylver,
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.trackClick(_vm.githubSylver)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-github"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.linkedinSylver,
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.trackClick(_vm.linkedinSylver)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin"
  })])])])])])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_c('h2', {
    staticClass: "section-heading"
  }, [_vm._v("The Team")]), _vm._v(" "), _c('h3', {
    staticClass: "section-subheading text-muted"
  }, [_vm._v("\"If it works, refactor it !\"")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 offset-lg-2 text-center"
  }, [_c('p', {
    staticClass: "large text-muted"
  }, [_vm._v("We are two young web developers who want to make a better world.")])])])
}]}

/***/ })
]),[46]);


// WEBPACK FOOTER //
// static/js/app.12578026f95da3db2a66.js